import { toast } from "react-toastify";

const toastSettings = {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
}

export function showNotification(type, message) {
  switch (type) {
    case "success":
      toast.success(message, toastSettings);
      return;
    case "warning":
      toast.warn(message, toastSettings);
      return;
    case "error":
      toast.error(message, toastSettings);
      return;
    default:
      return;
  }
};



// WEBPACK FOOTER //
// ./src/utils/toast.js